import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'

export default class Modalsenttouserex extends Component {
    constructor(props) {
        super(props);
        this.state = {
          modal: false,

          inside:"",
          faculty:"",
          Expert:[],
          idExpert:"",
          send_comment1:"",
          success:"",

          id_send:"",
          id_excomment:"",
          id_ex:"",
          show:"",
          commentex_admin:"",
          filecomment1:null,

        }

this.handleChange = this.handleChange.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangetype = this.handleChangetype.bind(this);
this.handleChange3 = this.handleChange3.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
  //this.props.selectatf();
}

handleChangetype(event) {    this.setState({commentex_admin: event.target.value});  }


 componentDidMount() {
      const { id_send } = this.props.id_send
      console.log(id_send);
      this.setState({   id_send:this.props.id_send,
                        id_excomment:this.props.id_excomment,
                        id_ex:this.props.id_ex
                    })

  }

//   getExpert() {
//     setTimeout(() => {
//       //ภายใน
//        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
//       .then(res => {
//         console.log(res);
//       //  this.setState({ bankname: res.data, loading: false })
//         this.setState({ Expert: res.data})
//       }) 

//     }, 0);

// }


  handleChange(event) {    this.setState({show: event.target.value});  }
  handleChange3(event) {    this.setState({filecomment1: event.target.files[0]});  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_send", this.state.id_send);
      datafrm.append("id_excomment", this.state.id_excomment);
      datafrm.append("id_ex", this.state.id_ex);
      datafrm.append("show", this.state.show);
      datafrm.append("commentex_admin", this.state.commentex_admin);
      datafrm.append("filecomment1", this.state.filecomment1);


//อัพเดทสถานะ
  Axios.post("https://edu.kpru.ac.th/conference/PHPAPI/updatecommentadminex.php",datafrm)
    .then(res => {
      console.log("response: ", res)

      if (res.data.status = 'success999') {
   
        Swal.fire({
         title: 'แจ้งผู้เขียนสำเร็จ',
         text: "Successfully notified author",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.props.list()
             this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
 
  
   })

 
}, 1000);

  }

  

    render() {
        
        return (
            <>
            <MDBBtn color="cyan" onClick={this.toggle} size='sm'>แจ้งสถานะ</MDBBtn>

            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>แจ้งสถานะบทความ </MDBModalHeader>
              <MDBModalBody>
              <div>

              <p>แจ้งสถานะบทความ</p>
                <select className="browser-default custom-select" onChange={this.handleChange}>
                        <option>------กรุณาเลือกสถานะ------</option>
                        <option value="0">ไม่ส่งแจ้ง</option>
                        <option value="1">ส่งแจ้ง</option>
                </select>

              <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="commentex_admin"
                                    value={this.state.commentex_admin} placeholder="กรุณาข้อเสนอแนะ" required />
              </div>

              <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์บทความ <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                     </div>


              </div>
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}
